module.exports = __webpack_public_path__ + "static/img/Pipa 40cm polos & pipa 40cm joint sock 20cm.91a4851.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Pipa 40cm polos & pipa 40cm joint sock 20cm.jpg
// module id = 91
// module chunks = 1